import React from 'react';
import { Card } from '../ui/card';
import { Mail, Star } from 'lucide-react';
import { mockMail } from '../../mock';

const MailWidget = () => {
  return (
    <Card className="bg-white/75 backdrop-blur-md border border-white/90 shadow-[0_4px_20px_rgba(99,102,241,0.06)] dark:bg-[#111114] dark:border-[#1e1e24] dark:shadow-none hover:shadow-[0_8px_30px_rgba(99,102,241,0.1)] dark:hover:shadow-none transition-all duration-300 overflow-hidden">
      <div className="p-6">
        {/* Header */}
        <div className="flex items-center justify-between mb-4 pb-4 border-b border-indigo-50/50 dark:border-[#1a1a20]">
          <div className="flex items-center space-x-3">
            <div className="p-2 bg-[rgba(99,102,241,0.08)] dark:bg-[rgba(167,139,250,0.1)] rounded-xl">
              <Mail className="text-indigo-500 dark:text-violet-400" size={24} />
            </div>
            <h2 className="text-xl font-semibold text-[#1a1625] dark:text-[#e5e5e5]">Mail</h2>
          </div>
          <span className="text-xs bg-indigo-50 text-indigo-600 dark:bg-[rgba(167,139,250,0.1)] dark:text-violet-400 px-2 py-1 rounded-full font-medium">
            {mockMail.filter((m) => !m.isRead).length}
          </span>
        </div>

        {/* Mail List */}
        <div className="space-y-2 max-h-[400px] overflow-y-auto custom-scrollbar">
          {mockMail.map((mail) => (
            <div
              key={mail.id}
              className={`p-4 rounded-xl hover:shadow-md transition-all duration-200 cursor-pointer border ${
                mail.isRead
                  ? 'bg-gradient-to-br from-indigo-50/30 to-white dark:from-[#16161b] dark:to-[#111114] border-indigo-50/80 dark:border-[#1a1a20]'
                  : 'bg-gradient-to-br from-indigo-50/60 to-purple-50/30 dark:from-[rgba(167,139,250,0.05)] dark:to-[#111114] border-indigo-100 dark:border-[rgba(167,139,250,0.1)]'
              }`}
            >
              <div className="flex items-start justify-between mb-2">
                <div className="flex-1 min-w-0">
                  <div className="flex items-center space-x-2">
                    <p
                      className={`text-sm font-medium truncate ${
                        mail.isRead
                          ? 'text-[#6b7280] dark:text-[#888]'
                          : 'text-[#1a1625] dark:text-[#e5e5e5]'
                      }`}
                    >
                      {mail.from}
                    </p>
                    {mail.isStarred && (
                      <Star size={12} className="text-amber-400 flex-shrink-0" fill="currentColor" />
                    )}
                  </div>
                </div>
                <span className="text-xs text-[#9ca3af] dark:text-[#555] ml-2">
                  {mail.date.toLocaleDateString('en-US', {
                    month: 'short',
                    day: 'numeric',
                  })}
                </span>
              </div>
              <p
                className={`text-sm mb-1 ${
                  mail.isRead
                    ? 'text-[#6b7280] dark:text-[#888]'
                    : 'text-[#1a1625] dark:text-[#e5e5e5] font-medium'
                }`}
              >
                {mail.subject}
              </p>
              <p className="text-xs text-[#9ca3af] dark:text-[#555] line-clamp-2">{mail.preview}</p>
            </div>
          ))}
        </div>
      </div>
    </Card>
  );
};

export default MailWidget;
